// firebaseConfig.js
import { initializeApp } from 'firebase/app'
import { getAuth,signInWithPopup,GoogleAuthProvider, signInWithRedirect, getRedirectResult } from 'firebase/auth'

import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig)

// ✅ Get Firebase Storage reference
const storage = getStorage(app)

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: 'select_account'
});

// ✅ Export for use in other files
export { app, storage, signInWithPopup, signInWithRedirect, getRedirectResult }
